import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { Alert } from "@mui/material";

/**
 * A failed save, said where the person is looking: put it next to the
 * dialog's Save button. When it appears it scrolls itself into view and
 * takes focus, so a screen reader reads it and, at 200 % zoom, it is not
 * left above the visible part of the dialog (CMS review round 2, georges-02).
 */
export default function SaveError({ message, sx }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!message || !ref.current) return;
    ref.current.scrollIntoView?.({ block: "nearest" });
    ref.current.focus?.({ preventScroll: true });
  }, [message]);
  if (!message) return null;
  return (
    <Alert ref={ref} severity="error" role="alert" tabIndex={-1} sx={{ outline: "none", ...sx }}>
      {message}
    </Alert>
  );
}

SaveError.propTypes = { message: PropTypes.node, sx: PropTypes.object };
